import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchUpcomingHoliday = createAsyncThunk('getHolidayData/fetchUpcomingHoliday',
  async (_, { rejectWithValue }) => {
    try {
    
      const url = `${api.holidays.upcomingHoliday}`
      console.log("url",url)
      const response = await axiosPrivate.get(url);
      return response.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const getUpcomingHolidaySlice = createSlice({
  name: 'holidays',
  initialState: {
    holidays: [],
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(fetchUpcomingHoliday.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(fetchUpcomingHoliday.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.holidays = action.payload;
        })
      .addCase(fetchUpcomingHoliday.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default getUpcomingHolidaySlice.reducer;